export default __webpack_public_path__ + "static/media/Cotton.6f1c1b17.png";